var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 10,
    viewBox: "0 0 30 10",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.79527.589844h2.03v8.819996h-1.82l-3.57-5.18v5.18h-2.029997v-8.819996h1.819997l3.57 5.179996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.0707 9.40984v-8.819996h6.3v1.959996h-4.27v1.4h3.92v1.96h-3.92v1.54h4.41v1.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.6447 4.22984-1.61 5.18h-1.54l-2.8-8.819996h1.96l1.68 5.459996 1.68-5.459996h1.26l1.68 5.459996 1.68-5.459996h1.96l-2.8 8.819996h-1.54z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIcon);
export default __webpack_public_path__ + "static/media/new-icon.b37ccb33a5664bef5fd22b52c88d6083.svg";
export { ForwardRef as ReactComponent };